import { useEffect } from "react";

export default function MoonshotProctoringOverlay({ open }) {
  //  Block all keyboard input while overlay is open
  useEffect(() => {
    if (!open) return;

    const blockKeyboard = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    };

    window.addEventListener("keydown", blockKeyboard, true);
    window.addEventListener("keyup", blockKeyboard, true);
    window.addEventListener("keypress", blockKeyboard, true);

    return () => {
      window.removeEventListener("keydown", blockKeyboard, true);
      window.removeEventListener("keyup", blockKeyboard, true);
      window.removeEventListener("keypress", blockKeyboard, true);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ pointerEvents: "all" }}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black opacity-90"
        onMouseDown={(e) => e.preventDefault()}
        onMouseUp={(e) => e.preventDefault()}
        onClick={(e) => e.preventDefault()}
        onContextMenu={(e) => e.preventDefault()}
      />

      {/* Content */}
      <div className="relative z-10 max-w-3xl px-6 text-center select-none">
        <h1 className="text-white text-3xl md:text-5xl font-bold mb-6">
          Please complete your NeedleEye snapshot
        </h1>

        <p className="text-white text-xl md:text-2xl leading-relaxed">
          Open the NeedleEye app and complete the snapshot within 30 seconds.
          <br />
          Failure to do so may impact your assessment.
        </p>
      </div>
    </div>
  );
}
